import { createColumnHelper } from '@tanstack/react-table'
import { Link } from 'react-router-dom'
import { Button, UncontrolledTooltip } from 'reactstrap'
import { dates } from 'src/helpers/displayhelpers'
import { Eeocs } from 'src/queries'
import { getDocumentData } from '../../helpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileContract, faInfoCircle, faSquarePollHorizontal } from '@fortawesome/free-solid-svg-icons'
import DateDisplay from 'src/components/DateDisplay'

type TData = Eeocs[0]

const columnHelper = createColumnHelper<TData>()

export interface ColumnsFnProps {
  toggleViewer: (id: string) => void
  toggleData: (data: Eeocs[0]) => void
}

export type Columns = (props: ColumnsFnProps) => Array<ReturnType<typeof columnHelper.accessor>>

const columns: Columns = ({ toggleViewer, toggleData }) => [
  columnHelper.accessor('_candidate.lastFirstName', {
    header: 'Candidate',
    cell: (info) => {
      const value = info.getValue()
      const id = info.row.original.candidate
      if (id !== undefined) {
        return (
          <Link to={`/cat/candidates/${String(id)}`}>{value}</Link>
        )
      }
      return value
    }
  }),
  columnHelper.accessor('status', {
    id: 'status',
    header: 'Status',
    cell: (info) => {
      const value = info.getValue()
      const isVoided = value === 'voided'
      const _id = String(info.row.original._id)
      const id = `VoidedTooltip-${_id}`
      return (
        <span className='text-capitalize'>
          {value}
          {isVoided && (
            <>
              <FontAwesomeIcon id={id} icon={faInfoCircle} className='ms-2' title='Voided' />
              <UncontrolledTooltip
                target={id}
                placement='right'
                key={_id}
              >
                <div className='text-start'>
                  Reason: {info.row.original.voidReason}<br />
                  Voided On: <DateDisplay date={info.row.original.voidedOn} display='system' />
                </div>
              </UncontrolledTooltip>
            </>
          )}
        </span>
      )
    }
  }),
  columnHelper.accessor(getDocumentData('Name'), {
    id: 'name',
    header: 'Name'
  }),
  columnHelper.accessor(getDocumentData('Position'), {
    id: 'position',
    header: 'Position'
  }),
  columnHelper.accessor(getDocumentData('Date Applied'), {
    id: 'dateApplied',
    header: 'Date Applied'
  }),
  columnHelper.accessor('createdAt', {
    header: 'Sent On',
    cell: (info) => {
      const value = info.getValue()
      return dates.system(value)
    }
  }),
  columnHelper.accessor('signedOn', {
    header: 'Signed On',
    cell: (info) => {
      const value = info.getValue()
      return dates.system(value)
    }
  }),
  columnHelper.accessor('candidate', {
    header: 'Actions',
    cell: (info) => {
      const signedOn = info.row.original.signedOn
      const hasSigned = signedOn !== undefined && signedOn !== null
      if (!hasSigned) {
        return null
      }
      return (
        <div className='h-100 d-flex justify-content-center align-items-center'>
          <Button
            color='link'
            className='text-reset'
            onClick={() => toggleData(info.row.original)}
            title='View Document Data'
          >
            <FontAwesomeIcon icon={faSquarePollHorizontal} />
          </Button>
          <Button
            color='link'
            className='text-reset'
            onClick={() => toggleViewer(info.row.original._id)}
            title='View Document'
          >
            <FontAwesomeIcon icon={faFileContract} />
          </Button>
        </div>
      )
    }
  })
]

export { columns }
